import { useMtlSchemaValidations } from '@melio/ap-domain';
import { object, SchemaOf, string } from 'yup';

import { FormFields } from './types';

export const useSchema = (): SchemaOf<FormFields> => {
  const { name } = useMtlSchemaValidations();

  return object().shape({
    firstName: name('firstName'),
    lastName: name('lastName'),
    email: string().email().required(),
  });
};
